<div class="info-field-list">
  <div class="info-field-list__title" *ngIf="title">
    {{ title }}
  </div>
  <div>
    <div class="info-field-list__row" *ngFor="let row of rows">
      <ui-info-field-item
        [label]="row.label | translate"
        [text]="row.text"
        [localDate]="row.localDate"
        [flat]="flat"
      ></ui-info-field-item>
    </div>
  </div>
</div>
